// extracted by mini-css-extract-plugin
export default {"file":"File-module--file--312e9"};